import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    runOwsRequestWithMonitor,
    Feature,
    UnifiedGroup,
    convertToUnifiedGroup,
    fullResponseOperationOption,
} from '../../../../shared';
import {
    GetUserUnifiedGroupsJsonResponse,
    RequestedUnifiedGroupsSet,
    UnifiedGroupsFilterType,
    UnifiedGroupsSortType,
    UnifiedGroupAdditionalPropertyType,
    GroupsSetType,
    getServiceAsync,
} from '../../../../service';

export function createUserUnifiedGroupsRequest(): Promise<GetUserUnifiedGroupsJsonResponse> {
    const requestedUnifiedGroupsSets: RequestedUnifiedGroupsSet[] = new Array();
    const sortType = UnifiedGroupsSortType.DisplayName as UnifiedGroupsSortType;
    requestedUnifiedGroupsSets.push({
        FilterType: UnifiedGroupsFilterType.All,
        SortType: sortType,
        SortDirection: sortType === UnifiedGroupsSortType.Relevance ? 'Descending' : 'Ascending',
        GroupsSetType: GroupsSetType.OwnerOfDeletedUnifiedGroups,
    });
    requestedUnifiedGroupsSets.push({
        FilterType: UnifiedGroupsFilterType.All,
        SortType: sortType,
        SortDirection: sortType === UnifiedGroupsSortType.Relevance ? 'Descending' : 'Ascending',
        GroupsSetType: GroupsSetType.MemberOfUnifiedGroups,
    });

    const additionalProperties: UnifiedGroupAdditionalPropertyType[] = [
        UnifiedGroupAdditionalPropertyType.MemberCount,
        UnifiedGroupAdditionalPropertyType.IsOwner,
        UnifiedGroupAdditionalPropertyType.UnseenMessagesCount,
        UnifiedGroupAdditionalPropertyType.Description,
    ];

    const requestHeaders = getJsonRequestHeader();
    requestHeaders.RequestServerVersion = 'V2018_01_08';

    return getServiceAsync().then(service =>
        service.Operation.getUserUnifiedGroupsOperation(
            {
                Header: requestHeaders,
                Body: service.Factory.getUserUnifiedGroupsRequest({
                    RequestedGroupsSets: requestedUnifiedGroupsSets,
                    AdditionalProperties: additionalProperties,
                }),
            },
            fullResponseOperationOption
        )
    );
}

export default function getUserUnifiedGroups(): Promise<UnifiedGroup[]> {
    return runOwsRequestWithMonitor({
        scenarioName: 'GetUserUnifiedGroups',
        feature: Feature.UnifiedGroups,
        operation: () => createUserUnifiedGroupsRequest(),
        transformResponse: (owsResponse: GetUserUnifiedGroupsJsonResponse) => {
            if (owsResponse.Body.GroupsSets && owsResponse.Body.GroupsSets.length > 0) {
                let groups = [];
                owsResponse.Body.GroupsSets.forEach(groupset => {
                    // filtering deleted groups without ExternalDirectoryObjectId
                    // TODO: remove the check once backend is fixed
                    const unifiedGroups =
                        groupset.GroupsSetType == 1
                            ? groupset.Groups.filter(group => !!group.ExternalDirectoryObjectId)
                            : groupset.Groups;
                    groups = groups.concat(
                        unifiedGroups.map(group => convertToUnifiedGroup(group, true))
                    );
                });

                return groups;
            }

            return [];
        },
    });
}
